import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const setupURI = config.setupApiUrl;

const dbBrokerStoreModule = {
  state: {
    queryPoolList: [],
    dbBrkList: [],
    dbBrokerQueryInfoList: [],
    dbBrokerDetailList: [],
    dbBrokerSelectBoxList: [],
  },
  mutations: {
    SET_STORE_QUERY_POOL_LIST(state, queryPoolList) {
      state.queryPoolList = queryPoolList;
    },
    SET_STORE_DBBRK_LIST(state, dbBrkList) {
      state.dbBrkList = dbBrkList;
    },
    SET_STORE_QUERY_INFO_LIST(state, dbBrokerQueryInfoList) {
      state.dbBrokerQueryInfoList = dbBrokerQueryInfoList;
    },
    SET_STORE_DBBRK_DETAIL_LIST(state, dbBrokerDetailList) {
      state.dbBrokerDetailList = dbBrokerDetailList;
    },
    SET_STORE_DBBRK_SELECT_BOX_LIST(state, dbBrokerSelectBoxList) {
      state.dbBrokerSelectBoxList = dbBrokerSelectBoxList.map((item) => {
        return {
          ...item,
          text: item.DBBRK_NM,
          value: item.DBBRK_ID,
        };
      });
    },
  },
  actions: {
    getQueryPoolList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/queryPool/list`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    saveQueryList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/queryPool/update`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    getDbBrokerList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/list`, params);
        commit('SET_STORE_DBBRK_SELECT_BOX_LIST', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    deleteDbBroker: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/delete`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    getBrokerQueryInfoList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/queryinfo/list`, params);
        commit('SET_STORE_QUERY_INFO_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_QUERY_INFO_LIST', []);
        throw err;
      }
    },
    addDbBroker: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/insert`, params);
        commit('SET_STORE_DBBRK_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DBBRK_LIST', []);
        throw err;
      }
    },
    getBrokerDetail: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${setupURI}/dbbrk/detail/${params.brokerId}`);
        commit('SET_STORE_DBBRK_DETAIL_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DBBRK_DETAIL_LIST', []);
        throw err;
      }
    },
    modifyDbBroker: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbbrk/update`, params);
        commit('SET_STORE_DBBRK_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DBBRK_LIST', []);
        throw err;
      }
    },
  },
  getters: {
    queryPoolList: (state) => state.queryPoolList,
    dbBrokerQueryInfoList: (state) => state.dbBrokerQueryInfoList,
    dbBrkList: (state) => state.dbBrkList,
    dbBrokerDetailList: (state) => state.dbBrokerDetailList,
    dbBrokerSelectBoxList: (state) => state.dbBrokerSelectBoxList,
  },
};

export default dbBrokerStoreModule;
